import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_2207_emp_grp_add: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Employee Group",
        style: {},
        childComponents: [
            {
                componentType: LayoutTypes.FORM,
                Name: "emp_grp_add",
                TableName: "employee_group",
                DisplayName: "Employee Group",
                columnNumber: "m1 t1 w3",
                style: {
                    padding: 10,
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                },
                childComponents: [
                    // Name (required)
                    {
                        componentType: ComponentType.TEXT_FIELD,
                        name: "txt_name",
                        label: "Name",
                        placeholder: "",
                        required: true,
                        BindValue: "txt_name",
                        Json_Attribute: "group_name",
                        showInSummary: true,
                        validation: [
                            {
                                rule: ValidationRule.REQUIRED,
                                message: "Name is required",
                            },
                        ],
                    },
                    // Time Shift
                    {
                        componentType: ComponentType.SEARCHABLE_DROPDOWN,
                        name: "drp_time_shift",
                        label: "Time Shift",
                        placeholder: "Select Time Shift",
                        required: false,
                        BindValue: "drp_time_shift",
                        Json_Attribute: "time_shift_id",
                        lookupName: "time_shift",
                    },
                    // Holiday Calendar
                    {
                        componentType: ComponentType.SEARCHABLE_DROPDOWN,
                        name: "drp_holiday_calendar",
                        label: "Holiday Calendar",
                        placeholder: "Select Holiday Calendar",
                        required: false,
                        BindValue: "drp_holiday_calendar",
                        Json_Attribute: "holiday_calendar_id",
                        lookupName: "holiday_calendar",
                    },
                ],
            },
            {
                componentType: ComponentType.BUTTON,
                name: "Submit",
                onPressAction: "save_emp_group",
                style: {
                    backgroundColor: "var(--primary-green)",
                },
            },
        ],
    },
];
